import { useState } from 'react';

/**
 * Custom hook for handling swipe gestures
 * @param {Function} onSwipeLeft - Callback for left swipe (next)
 * @param {Function} onSwipeRight - Callback for right swipe (previous)
 * @param {number} minSwipeDistance - Minimum distance to trigger swipe (default: 50px)
 */
const useSwipe = (onSwipeLeft, onSwipeRight, minSwipeDistance = 50) => {
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [isSwiping, setIsSwiping] = useState(false);

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
        setIsSwiping(true);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        setIsSwiping(false);
        
        if (!touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        
        if (isLeftSwipe && onSwipeLeft) {
            onSwipeLeft();
        }
        
        if (isRightSwipe && onSwipeRight) {
            onSwipeRight();
        }
    };

    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd,
        isSwiping
    };
};

export default useSwipe;
